import {
  computed,
  effect,
  inject,
  Injectable,
  InjectionToken,
  signal,
  WritableSignal,
} from '@angular/core';

import { Select2Item, SelectFilterFn } from '../types';
import { SelectController } from './select-controller.service';

export const SELECT_FILTERED_ITEMS = new InjectionToken<WritableSignal<Select2Item[]>>(
  'Filtered items stream',
);

export const SELECT_ITEMS = new InjectionToken<WritableSignal<Select2Item[]>>('Items stream');

@Injectable()
export class SelectItemsService {
  public itemsToRender = signal<Select2Item[]>([]);
  public defaultItems = signal<Select2Item[]>([]);
  public defaultFilteredItems = computed(() => this.filterItems(this.defaultItems()));

  private filtersMap = signal<Record<string, SelectFilterFn>>({});

  constructor(private selectController: SelectController) {
    const allItems = inject(SELECT_ITEMS, { optional: true }) ?? this.defaultItems;
    const filteredItems =
      inject(SELECT_FILTERED_ITEMS, { optional: true }) ?? this.defaultFilteredItems;

    effect(() => this.selectController.itemSelector.setItems(allItems()), {
      allowSignalWrites: true,
    });
    effect(() => this.itemsToRender.set(filteredItems()), { allowSignalWrites: true });
  }

  public filterRemove(name: string) {
    this.filtersMap.update(({ [name]: _, ...filtersMap }) => filtersMap);
  }

  public filterRegister(name: string, fn: SelectFilterFn) {
    this.filtersMap.update(filtersMap => ({
      ...filtersMap,
      [name]: fn,
    }));
  }

  public filterItems(items: Select2Item[]): Select2Item[] {
    const filters = Object.values(this.filtersMap());
    return items.filter(item => filters.every(filter => filter(item)));
  }

  public setItems(items: Select2Item[]) {
    this.defaultItems.set(items);
  }
}
